/* eslint-disable max-len */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import _ from 'lodash';
import moment from 'moment';
import { PROJECT_TYPES_ENUMS } from '../../../core/constants/projects';
import { requiredFields } from './constants';

export const getScreenerSurvey = (testerStudy) => {
  const { project: { surveys } } = testerStudy;
  const [screener] = surveys.filter((survey) => survey.surveyType === 'screener');
  return screener ?? null;
};

export const isLastQuestion = (currentQuestion, screenerQuestions) => (currentQuestion + 1) === screenerQuestions.length;

export const getUpcomingConversations = (studies = []) => studies.filter((study) => {
  const [tester = {}] = study.testers;
  const { testSessions = [] } = tester;
  const startTime5HoursLater = moment(testSessions[0]?.startAt).add(5, 'hours');
  const now = moment().toDate();
  const approvedTestSessions = testSessions.filter(({
    bookingStatus, endAt,
  }) => bookingStatus === 'confirmed' && study.testType === PROJECT_TYPES_ENUMS.MODERATED && now < startTime5HoursLater && endAt);

  if (!_.isEmpty(approvedTestSessions)) return study;
});
export const getUnfinishedStudies = (studies = [], ...upcoming) => {
  const upcomingIds = upcoming.flat().map(({ id }) => id);
  return studies.filter((study) => {
    const [tester = {}] = study.testers;
    const { testSessions = [] } = tester;
    const [testSession] = testSessions;
    // checking if it is UNMODERATED or !expired because unmoderated studies can be expired if expiration count is not greater than 3
    if (testSession && (study.testType === PROJECT_TYPES_ENUMS.UNMODERATED || !testSession.expired) && !upcomingIds.includes(study.id)) {
      return study;
    }
  });
};
export const getInvitedStudies = (studies = [], ...filtered) => studies.filter((study) => {
  const filteredIds = filtered.flat().map(({ id }) => id);
  if (!_.isEmpty(study.testers) && study.testers[0].invitedBy && !filteredIds.includes(study.id)) return study;
});

export const hasBooking = (testSessions) => {
  if (_.isEmpty(testSessions)) return false;

  const validBookings = testSessions.filter(({
    bookingStatus, expired, startAt, endAt,
  }) => bookingStatus === 'confirmed' && !expired && startAt && endAt);

  return !_.isEmpty(validBookings);
};

export const isRemoved = (tester) => {
  if (_.isEmpty(tester)) return false;
  return tester.removed;
};

export const getBooking = (testSessions) => {
  if (_.isEmpty(testSessions)) return null;

  const validBookings = testSessions.filter(({ bookingStatus, expired }) => bookingStatus === 'confirmed' && !expired);

  return validBookings;
};

/**
 *  This method checks if an user has answered the screener questions of a study.
 *  This is necessary to check if an user has answered all the screener questions of a study he was invited to.
 */
export const checkScreenerAnswers = (screenerSurvey, testers) => {
  if (!_.isEmpty(testers) && screenerSurvey && !_.isEmpty(screenerSurvey.questions)) {
    const { screenerSessionAnswers = [] } = testers[0].screenerSession || {};
    const { questions } = screenerSurvey;

    return screenerSessionAnswers.length === questions.length;
  }

  return true;
};

export const mapProjectSegment = (projectSegment) => {
  const { project } = projectSegment;
  const {
    id: projectId,
    name,
    testType,
    status,
    sessionDuration,
    welcomeTitle,
    welcomeContent,
    timeZone,
    projectConsentForms,
    faceRecording,
  } = project;

  const segmentProject = {
    ...projectSegment,
    projectId,
    name,
    testType,
    status,
    sessionDuration,
    welcomeTitle,
    welcomeContent,
    timeZone,
    projectConsentForms,
    faceRecording,
  };

  delete segmentProject.project;
  return segmentProject;
};

export const isCompletedProfile = (profile) => {
  let isComplete = !_.isNull(profile);

  if (isComplete) {
    _.forEach(requiredFields, (field) => {
      switch (field) {
        case 'state':
          if (profile.country === 'us') {
            isComplete = !!profile[field];
          }
          break;
        default:
          isComplete = !!profile[field];
      }
    });
  }

  return isComplete;
};
